import { render, staticRenderFns } from "./AdminTextCourseList.vue?vue&type=template&id=0c5aae28&scoped=true&"
import script from "./AdminTextCourseList.vue?vue&type=script&lang=js&"
export * from "./AdminTextCourseList.vue?vue&type=script&lang=js&"
import style0 from "./AdminTextCourseList.vue?vue&type=style&index=0&id=0c5aae28&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c5aae28",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCol,VContainer,VDataTable,VDialog,VIcon,VTextField})
